module.exports = __webpack_public_path__ + "static/img/compose12_1.1d54c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compose12_1.png
// module id = CmbB
// module chunks = 1